module.exports = __webpack_public_path__ + "img/unluck.dcbae938.png";